import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import snackbarReducer from './snackbarReducer';
import cartReducer from './cartReducer';
import sidebarReducer from './sideBarReducer';
import sadyasthitiReducer from './pmp/sadyasthitiReducer';
import updateGeoStructureReducer from './pmp/geoStructureReducer';

// ===========================|| COMBINE REDUCER ||=========================== //

const reducer = combineReducers({
    centrallySelectedgeoStructure: updateGeoStructureReducer,
    sadyasthiti: sadyasthitiReducer,
    customization: customizationReducer,
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    sideBar: persistReducer(
        {
            key: 'sideBar',
            storage
        },
        sidebarReducer
    )
});

export default reducer;
